import { useRef } from "react";
import FormattingToolbar from "../FormattingToolBar";
import MarkdownRenderer from "../MarkDown";

const AddMtpModal = ({
  isOpen,
  content,
  onContentChange,
  onSubmit,
  onClose,
  isLoading,
  error,
}) => {
  const textareaRef = useRef(null);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-lg max-w-4xl w-full max-h-[60vh] overflow-y-auto">
        {/* Modal Header */}
        <div className="sticky top-0 bg-gray-50 border-b p-4 flex items-center justify-between">
          <h2 className="text-xl font-semibold text-gray-800">Create MTP Paper</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 text-2xl"
          >
            ×
          </button>
        </div>

        {/* Modal Body */}
        <div className="p-6 space-y-6">
          {/* Error */}
          {error && (
            <div className="rounded-lg bg-red-50 border border-red-200 px-4 py-2 text-red-600 text-sm">
              {error}
            </div>
          )}

          {/* Editor */}
          <div className="bg-white rounded-lg border border-gray-200">
            {/* Toolbar */}
            <div className="border-b p-2 bg-gray-50">
              <FormattingToolbar
                textareaRef={textareaRef}
                value={content}
                onChange={onContentChange}
              />
            </div>

            {/* Textarea */}
            <textarea
              ref={textareaRef}
              value={content}
              onChange={(e) => onContentChange(e.target.value)}
              disabled={isLoading}
              placeholder="Enter MTP paper content here..."
              className="w-full min-h-[300px] p-4 resize-none
                         text-gray-800 text-sm leading-relaxed
                         focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Preview */}
          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-3">
              Preview
            </h3>
            <div className="bg-gray-50 rounded-lg border border-gray-200 p-4 max-h-[300px] overflow-y-auto">
              <MarkdownRenderer content={content} />
            </div>
          </div>

          {/* Modal Footer */}
          <div className="flex gap-3 justify-end border-t pt-4">
            <button
              onClick={onClose}
              disabled={isLoading}
              className="px-4 py-2 rounded-lg border border-gray-300 text-gray-700 font-medium
                         hover:bg-gray-50 disabled:opacity-50"
            >
              Cancel
            </button>

            <button
              onClick={onSubmit}
              disabled={isLoading}
              className="px-6 py-2 rounded-lg bg-blue-600 text-white font-medium
                         hover:bg-blue-700 disabled:opacity-50 transition"
            >
              {isLoading ? "Creating..." : "Create MTP"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddMtpModal;
